import { defineModule } from '../types.js';
export default defineModule({
    id: 'tresorerie-veille',
    nom: 'Trésorerie et veille',
    description: 'Trésorerie et besoin en fonds de roulement, veille des réserves, alertes.',
    famille: 'pilotage',
    dependances: [],
    activableParDefaut: true,
    desactivable: true,
    routesApi: [],
    droits: {
        'tresorerie-veille.consulter': { description: 'Consulter la trésorerie, la veille et les alertes', niveau: 'lecture' },
    },
    navigation: [
        { cle: 'tresorerie', libelle: 'Trésorerie et BFR', picto: '◈', groupe: 'Prévisionnel', ordre: 60, droit: 'tresorerie-veille.consulter' },
        { cle: 'veille', libelle: 'Veille des réserves', picto: '◷', groupe: 'Pilotage', ordre: 70, droit: 'tresorerie-veille.consulter' },
        { cle: 'alertes', libelle: 'Alertes', picto: '⚠', groupe: 'Pilotage', ordre: 85, droit: 'tresorerie-veille.consulter' },
    ],
});
//# sourceMappingURL=tresorerie-veille.js.map